import { useMemo } from 'react'

import { createMuiTheme, Theme } from '@material-ui/core'
import createPalette from '@material-ui/core/styles/createPalette'

import generateOverrides from '~/theme/overrides'
import palette from '~/theme/palette'

import theme from '~/theme'

const useAppTheme = (uiSettings: Partial<UiSettings>): Theme => {
  const appTheme = useMemo(() => {
    const currentPalette = createPalette({
      ...palette,
      primary: {
        main: uiSettings?.base_color || '#973695',
        light: uiSettings?.base_secondary_color || 'rgba(151, 54, 149, 0.1)'
      },
      secondary: {
        main: uiSettings?.main_secondary_color || '#FAFAFA'
      },
      text: {
        primary: uiSettings?.main_text_color || '#595959',
        secondary: uiSettings?.secondary_text_color || '#333'
      },
      grey: {
        ...palette.grey,
        '100': uiSettings?.main_color || '#E9EFF7'
      },
      background: {
        default: uiSettings?.background_color || '#F6F8F9'
      },
      bg: {
        headerBg: uiSettings?.header_color || '#FFF',
        footerBg: uiSettings?.footer_color || '#FFF'
      }
    })

    return createMuiTheme({
      ...theme,
      palette: currentPalette,
      overrides: generateOverrides(currentPalette)
    })
  }, [uiSettings])

  return appTheme
}

export default useAppTheme
